import baseService from '../utils/axios';

export const getCurrentMonthUsage = async () => baseService.get(
  '/usage/current_month'
);

export const getTrackingEntries = async (page: number, pageSize: number) => {
  return baseService.get('/usage/tracking_entries', {
    params: {
      page,
      page_size: pageSize
    }
  });
};

export const getTrackingEntriesByDateRange = async (
  fromYear: number,
  fromMonth: number, 
  fromDay: number,
  toYear: number,
  toMonth: number,
  toDay: number,
  page: number = 1,
  pageSize: number = 100
) => {
  return baseService.post('/usage/tracking_entries_by_date_range', {
    from_year: fromYear,
    from_month: fromMonth,
    from_day: fromDay,
    to_year: toYear,
    to_month: toMonth,
    to_day: toDay,
    page,
    page_size: pageSize
  });
};

export const createTrackingEntriesExport = async (
  fromYear: number,
  fromMonth: number,
  fromDay: number, 
  toYear: number,
  toMonth: number,
  toDay: number,
  pageSize: number = 100
) => {
  return baseService.post('/usage/create_entries_export', {
    from_year: fromYear,
    from_month: fromMonth,
    from_day: fromDay,
    to_year: toYear,
    to_month: toMonth,
    to_day: toDay,
    page_size: pageSize
  });
};

export const getNewFeatureTypesUsage = async () => {
  return baseService.get('/usage/admin_new_feature_types_usage');
};

export const getSuggestionsEntriesStats = async (
  fromYear: number,
  fromMonth: number,
  fromDay: number,
  toYear: number,
  toMonth: number,
  toDay: number,
  category: string = 'ANSWERING',
  page: number = 1,
  pageSize: number = 100
) => {
  return baseService.post('/usage/suggestions_entries_stats', {
    from_year: fromYear,
    from_month: fromMonth,
    from_day: fromDay,
    to_year: toYear,
    to_month: toMonth,
    to_day: toDay,
    category,
    page,
    page_size: pageSize
  });
};
